import { call, put, select } from 'redux-saga/effects';
import { iActionList } from 'domain/interfaces/redux/sacRequest/list';
import { ListSacRequest } from 'domain/usecases/sacRequest/remote/ListSacRequest';
import { makeRemoteListSacRequest } from 'main/factories/usecases/sacRequest/ListSacRequestFactory';
import {
  listSuccess,
  listFailed,
} from 'data/store/reducer/sacRequest/actions/list';

export function* onList(action: iActionList) {
  const remoteListSacRequest = makeRemoteListSacRequest();

  try {
    const response: ListSacRequest.Model = yield call(
      remoteListSacRequest.list,
      action.payload,
    );
    yield put(
      listSuccess({
        ...response,
      }),
    );
  } catch (e) {
    yield put(listFailed());
  }
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export function onListSuccess() {}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export function onListFailed() {}
